import React, { useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ConnectionTester = ({ connId, params }) => {
  const [q, setQ] = useState('');
  const [out, setOut] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (e) => {
    e.preventDefault(); setBusy(true);
    try { setOut((await axios.post(`${API}/business/api-connections/${connId}/test`, { query: q }, { params })).data); }
    catch (err) { setOut({ ok: false, result: err.response?.data?.detail?.toString() || 'Test failed' }); }
    setBusy(false);
  };

  return (
    <form onSubmit={run} className="mt-3 pt-3 border-t border-border space-y-2" data-testid={`api-connection-tester-${connId}`}>
      <div className="flex gap-2">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Try a search, e.g. 225/65R17" required data-testid="api-connection-test-input" />
        <Button type="submit" disabled={busy} data-testid="api-connection-test-run-btn">{busy ? 'Checking...' : 'Test'}</Button>
      </div>
      {out && (
        <div className={`text-xs rounded-lg p-3 max-h-48 overflow-auto break-all ${out.ok ? 'bg-green-50 text-green-900' : 'bg-red-50 text-red-800'}`} data-testid="api-connection-test-result">
          <p className="font-semibold mb-1">{out.ok ? 'Worked. This is what your Pro sees:' : 'Did not work:'}</p>
          {out.result}
        </div>
      )}
    </form>
  );
};
